import InputSwitch from "../../controls/InputSwitch";
import { action, controller, Server } from "../../api/Server";
import { formatDate, ToFormData } from "../../hooks/Method";

const ChangeStatus = ({ value, setTblData }) => {
  const handleInpChg = (id) => {
    Server(controller.PayMethod + action.ChangeStatus).post(
      ToFormData({
        id: id,
        dateTime: new Date().toISOString(),
      }),
      (res) => {
        res && res.status === 200
          ? setTblData((prev) => [
              ...prev.map((j) =>
                j.id === id
                  ? {
                      ...j,
                      isActive: res.result?.isActive,
                      updateDate: formatDate(res.result?.updateDate),
                    }
                  : j
              ),
            ])
          : console.error("Error: ", res?.msg);
      }
    );
  };

  return (
    <InputSwitch
      checked={value.isActive}
      onChange={() => handleInpChg(value.id)}
    />
  );
};

export default ChangeStatus;
